<template>
  <v-snackbar
    v-model="enableSnackbar"
    :timeout="timeout"
    color="info"
    light
  >
    <h3 v-if="title" class="white--text">{{ title }}</h3>
    <div class="d-flex align-center">
      <h4 v-if="subTitle" class="white--text mb-0 mr-2">{{ subTitle }}：</h4>
      <div>
        <div
          v-for="(item, index) in messages"
          :key="`message_${index}`"
          class="white--text"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div class="text-right pt-2">

      <v-btn
        color="default"
        light
        small
        @click="hideSnackbar"
      >
        閉じる
      </v-btn>
      &nbsp;
      <v-tooltip
        v-if="enableCopy"
        v-model="enableTooltip"
        top
        style="z-index: 10000;"
      >
        <template v-slot:activator="{ attrs }">
          <v-btn
            color="primary"
            light
            small
            v-bind="attrs"
            @click.stop="copyButtonClickEvent"
          >
            コピーする
          </v-btn>
        </template>
        <span>{{ copyMessage }}</span>
      </v-tooltip>
    </div>
  </v-snackbar>
</template>

<script>

import { mapState, mapActions } from 'vuex'

/**
 * example
 * <snackbar />
 */
export default {
  name: 'FreelySnackbarComponent',
  data () {
    return {
      enableSnackbar: false,
      enableTooltip: false,
      copyMessage: null
    }
  },
  computed: {
    ...mapState('freelySnackbar', {
      enable: 'enable',
      title: 'title',
      subTitle: 'subTitle',
      messages: 'messages',
      color: 'color',
      timeout: 'timeout',
      enableCopy: 'enableCopy'
    }),
  },
  watch: {
    enable (newVal) {
      if (newVal) {
        this.enableSnackbar = newVal;
      }
    },
    enableSnackbar (newVal) {
      if (!newVal) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions('freelySnackbar', {
      hide: 'hide'
    }),
    /**
     * コピーボタン クリックイベント
     */
    copyButtonClickEvent () {
      if (!navigator.clipboard) {
        alert("このブラウザは対応していません");
        return;
      }

      navigator.clipboard.writeText(this.messages.join(',')).then(
        () => {
          this.showTooltip('コピーしました');
        },
        () => {
          this.showTooltip('コピーに失敗しました')
        });
    },
    /**
     * ツールチップの表示
     * @param message
     */
    showTooltip (message) {
      this.copyMessage = message;
      this.enableTooltip = true;

      setTimeout( () => {
        this.enableTooltip = false;
      }, 1000)
    },
    hideSnackbar () {
      this.enableSnackbar = false;
    }
  }
}

</script>

<style scoped lang="scss">
</style>
